import { Dropdown } from "antd";

import { getSalesAgentModelOption, type SalesAgentModelOptionId, salesAgentModelOptions } from "./constants";

export const SalesAgentModelPicker = ({
  disabled,
  selectedModelId,
  onChange,
}: {
  disabled?: boolean;
  selectedModelId: SalesAgentModelOptionId;
  onChange: (modelId: SalesAgentModelOptionId) => void;
}) => {
  const selectedModelOption = getSalesAgentModelOption(selectedModelId);
  const costBadgeClassName =
    "inline-flex h-5 min-w-6 items-center justify-center rounded-md border border-amber-200/80 bg-white px-1.5 font-mono text-[12px] font-semibold leading-none tracking-tight text-amber-700 shadow-sm";

  return (
    <Dropdown
      disabled={disabled}
      trigger={["click"]}
      placement="topLeft"
      menu={{
        selectedKeys: [selectedModelId],
        items: salesAgentModelOptions.map((option) => ({
          key: option.id,
          label: (
            <div className="flex min-w-[240px] items-center justify-between gap-4">
              <span className="font-medium text-gray-900">{option.label}</span>
              <span className="flex items-center gap-1.5">
                {option.costBadge ? <span className={costBadgeClassName}>{option.costBadge}</span> : null}
                <span className="rounded-full bg-gray-100 px-2 py-0.5 text-[11px] font-medium uppercase text-gray-500">
                  {option.reasoningEffort}
                </span>
              </span>
            </div>
          ),
          onClick: () => onChange(option.id),
        })),
      }}
      overlayClassName="[&_.ant-dropdown-menu]:rounded-xl [&_.ant-dropdown-menu]:border [&_.ant-dropdown-menu]:border-gray-200 [&_.ant-dropdown-menu]:bg-white [&_.ant-dropdown-menu]:p-1.5 [&_.ant-dropdown-menu]:shadow-xl [&_.ant-dropdown-menu-item]:rounded-lg [&_.ant-dropdown-menu-item]:px-3 [&_.ant-dropdown-menu-item]:py-2 [&_.ant-dropdown-menu-item-active]:bg-gray-100"
    >
      <button
        type="button"
        disabled={disabled}
        className="inline-flex h-9 max-w-[220px] items-center gap-2 rounded-full px-2.5 text-sm text-gray-600 transition-colors hover:bg-gray-100 hover:text-gray-950 disabled:pointer-events-none disabled:opacity-50"
        title={`Model: ${selectedModelOption.label}, reasoning ${selectedModelOption.reasoningEffort}`}
      >
        <span className="flex size-4 items-center justify-center rounded-full bg-gray-950 text-[10px] font-semibold text-white">
          AI
        </span>
        <span className="truncate">{selectedModelOption.label}</span>
        {selectedModelOption.costBadge ? (
          <span className={costBadgeClassName}>{selectedModelOption.costBadge}</span>
        ) : null}
        <span className="rounded-full bg-gray-100 px-1.5 py-0.5 text-[11px] font-medium uppercase text-gray-500">
          {selectedModelOption.reasoningEffort}
        </span>
      </button>
    </Dropdown>
  );
};
